import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './i18n/en';
import { extractUserCode } from './utility/helpers/utils';

const code = extractUserCode();

const resources = {
  en: {
    translation: en,
  },
};

i18n.use(initReactI18next).init({
  resources,
  lng: code || 'en',
  fallbackLng: 'en',
  keySeparator: false,
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
